module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-wepay-flow__li",
    class: {
      'weui-wepay-flow__li_done': _vm.isDone
    }
  }, [_c('div', {
    staticClass: "weui-wepay-flow__state"
  }, [_vm._v(_vm._s(_vm.state))]), _vm._v(" "), _c('p', {
    class: ("weui-wepay-flow__title-" + _vm.titlePosition)
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13306f0d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/flow/flow-state.vue
// module id = 647
// module chunks = 0